import ToggleSwitch from "Common/ToggleSwitch";
import { Dispatch, SetStateAction, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

interface PopupImageModalProps {
  show: any;
  clickHandler: any;
  setNameDomian: Dispatch<SetStateAction<string>>;
  nameDomain: string;
  setHostName: Dispatch<SetStateAction<string>>;
  hostName: string;
  updateUpUp: (data: any) => Promise<void>;
}

const PopupImageModal = ({
  show,
  clickHandler,
  setNameDomian,
  nameDomain,
  setHostName,
  hostName,
  updateUpUp,
}: PopupImageModalProps) => {
  const [showToggle, setToggle] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [tvType, setTvType] = useState<string>(""); // default
  const [imageError, setImageError] = useState<string>("");

  const toggleSwitch = () => {
    setToggle(!showToggle);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const maxSizeInBytes = 1 * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        setImageError("Image size should not exceed 1MB.");
        setSelectedImage(null);
      } else {
        setSelectedImage(file);
        setImageError("");
      }
    }
  };

  const validateFields = (): boolean => {
    let isValid = true;

    if (!selectedImage) {
      setImageError("Please select an image.");
      isValid = false;
    }

    return isValid;
  };

  const handleUpdate = async () => {
    if (!validateFields()) {
      return;
    }

    const formData = new FormData();
    if (hostName) {
      formData.append("website", nameDomain);
    }
    formData.append("content_type", "Popup");
    formData.append("is_active", showToggle ? "true" : "false");
    formData.append("image", selectedImage as Blob);
    formData.append("content_for", tvType || "mobile");

    await updateUpUp(formData);
    setTvType("");
  };
  return (
    <Modal
      size="lg"
      show={show}
      onHide={clickHandler}
      className="zoomIn"
      scrollable
    >
      <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
        <div>
          Update Popup Image {hostName ? "of" : ""} {hostName}
        </div>
        <Button
          variant="light btn-sm"
          onClick={() => {
            clickHandler();
            setImageError("");
          }}
        >
          <i className="ri-close-line fs-xl align-middle"></i>
        </Button>
      </Modal.Header>
      <Modal.Body className="fs-md">
        <Row className="align-items-center g-3">
          {hostName && (
            <>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Website Name</Form.Label>
                  <Form.Control value={hostName} readOnly type="text" />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label>Site Title Data</Form.Label>
                  <Form.Control value={nameDomain} readOnly type="text" />
                </Form.Group>
              </Col>
            </>
          )}

          <Col lg={6}>
            <Form.Group>
              <Form.Label>Image</Form.Label>
              <Form.Control
                accept="
                image/jpeg,
                image/jpg,
                image/png,
                image/webp,
                image/bmp,
                image/tiff,
                image/svg+xml,
                image/x-icon,
                image/heic,
                image/heif
              "
                name="image"
                type="file"
                onChange={handleImageChange}
              />
              {imageError && (
                <div className="text-danger mt-1">{imageError}</div>
              )}
            </Form.Group>
          </Col>
          <Col lg={6}>
            <Form.Group className="d-flex align-items-center pt-3">
              <Form.Label className="mb-0 me-3">Status</Form.Label>
              <ToggleSwitch
                On="On"
                Off="Off"
                onChange={toggleSwitch}
                checked={showToggle}
              />
            </Form.Group>
          </Col>
          <Col lg={6}>
            <Form.Group className="pt-3 pb-2">
              <Form.Label>Device</Form.Label>
              <Row className="form-check d-flex mb-2">
                <Col lg={6}>
                  <Form.Check
                    type="radio"
                    name="tvType"
                    id="Premimum"
                    checked={tvType === "desktop"}
                    onChange={() => setTvType("desktop")}
                  />
                  <Form.Label htmlFor="Premimum">Desktop</Form.Label>
                </Col>
                <Col lg={6}>
                  <Form.Check
                    type="radio"
                    name="tvType"
                    id="Normal"
                    checked={tvType === "mobile"}
                    onChange={() => setTvType("mobile")}
                  />
                  <Form.Label htmlFor="Normal">Mobile</Form.Label>
                </Col>
              </Row>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="border-top">
        <Button onClick={handleUpdate}>Update</Button>
        <Button
          variant="light"
          onClick={() => {
            clickHandler();
            setImageError("");
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PopupImageModal;
